import XTbl, {Xtc} from '../../components/new-x-table/index';

const tbl = new XTbl('personelContactEndNextMonth/table', 'لیست پرسنل')
tbl.add(new Xtc('personnel.id', 'کد پرسنلی').filterText())
tbl.add(new Xtc('personnel.name', 'نام و نام خانوادگی').filterText())
tbl.add(new Xtc('start_atj', 'تاریخ شروع قرارداد').noSort())
tbl.add(new Xtc('end_atj', 'تاریخ اتمام قرارداد').noSort())
tbl.add(new Xtc('date_work', 'مدت تصدی (روز)'))
export default tbl;
